import {
    USER_SUBMIT_FRUI_PFXH_BEGIN,
    USER_SUBMIT_FRUI_PFXH_SUCCESS,
    USER_SUBMIT_FRUI_PFXH_FAILURE,
    USER_SUBMIT_FRUI_PFXH_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_pfxh(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_SUBMIT_FRUI_PFXH_BEGIN,
      });

    const promise = new Promise((resolve, reject) => {
        request({
          method:params.id !== undefined ? 'PUT' : 'POST',
          url:"/api/basic/gc/lng",
          data: params,
        }).then( data => {
            dispatch({
                type: USER_SUBMIT_FRUI_PFXH_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: USER_SUBMIT_FRUI_PFXH_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_pfxhError() {
    return {
      type: USER_SUBMIT_FRUI_PFXH_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_SUBMIT_FRUI_PFXH_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_pfxhPending: true,
          submitFrui_pfxhError: null,
        };
  
      case USER_SUBMIT_FRUI_PFXH_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFrui_pfxhPending: false,
          submitFrui_pfxhError: null,
        };
  
      case USER_SUBMIT_FRUI_PFXH_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_pfxhPending: false,
          submitFrui_pfxhError: action.data.error,
        };
  
      case USER_SUBMIT_FRUI_PFXH_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_pfxhError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/submitFrui_pfxh.js